import { Button } from "@heroui/react";

export const CustomerInfoCard = ({
  label,
  value,
  icon: ActionIcon,
  onClick,
  href,
}: {
  label: string;
  value: string;
  icon?: React.ElementType;
  onClick?: () => void;
  href?: string;
}) => {
  const button = ActionIcon && (
    <Button
      isIconOnly
      variant="light"
      size="sm"
      onPress={onClick}
      className="text-gray-500 hover:text-gray-700"
      as={href ? "a" : "button"}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ActionIcon className="h-4 w-4" />
    </Button>
  );

  return (
    <div className="flex-1 rounded-md border border-gray-200 bg-gray-50 px-4 py-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-1">
          <div className="text-base font-semibold leading-none">{value}</div>
          <div className="text-sm font-medium leading-none text-gray-500">
            {label}
          </div>
        </div>
        {button && <div className="flex gap-1">{button}</div>}
      </div>
    </div>
  );
};
